module.exports = __webpack_public_path__ + "static/media/EXPORT_BULK_UPLOAD_VAT_PARTNER_3.00.9033ca9d.xlsx";